import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useAuth } from '../context/AuthContext'
import SEO from '../components/SEO'
import LanguageSwitcher from '../components/LanguageSwitcher'
import LearnerDashboard from '../components/learners/LearnerDashboard'

export default function LearnPage() {
  const router = useRouter()
  const { isAuthenticated, authToken, loading: authLoading } = useAuth()
  const [categories, setCategories] = useState([])
  const [progress, setProgress] = useState(null)
  const [loading, setLoading] = useState(true)
  const [userPlanType, setUserPlanType] = useState('free')

  useEffect(() => {
    if (authLoading) return
    if (!isAuthenticated) {
      router.push('/login')
      return
    }
    if (authToken) {
      fetchData()
    }
  }, [isAuthenticated, authToken, authLoading])

  const fetchData = async () => {
    try {
      const api = (await import('../services/api')).default
      const [catRes, progRes, subRes] = await Promise.all([
        api.get('/v1/learners/categories/'),
        api.get('/v1/learners/progress/'),
        api.get('/v1/credits/subscription/').catch(() => ({ data: null })),
      ])
      setCategories(catRes.data)
      setProgress(progRes.data)
      const planType = subRes.data?.plan?.plan_type || 'free'
      setUserPlanType(planType)
    } catch (err) {
      console.error('Failed to fetch learner data:', err)
    }
    setLoading(false)
  }

  return (
    <div className="relative min-h-screen bg-gray-50 dark:bg-gray-900">
      <SEO
        title="Learn Haitian Creole — Flashcards, Quizzes & Audio — CreoleCentric"
        description="Master Haitian Creole vocabulary with interactive flashcards, quizzes, and spaced repetition. Beginner to expert levels with native pronunciation. Available in English, French, Spanish, and Brazilian Portuguese. Free."
        path="/learn"
      />
      {/* Shift the switcher one flag-width + gap (~28px) further left so it
          clears the theme/menu icons the outer chrome may render near the top-right corner. */}
      <LanguageSwitcher variant="top-right" className="!right-11" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <LearnerDashboard
          categories={categories}
          progress={progress}
          loading={loading}
          userPlanType={userPlanType}
        />
      </div>
    </div>
  )
}
